module.exports = {
  "primaryColour": "#FF5F00",
  "secondaryColour": "#1c4586",
  "bgGrey": "rgba(231, 241, 252, 0.98)",
  "grey": "#e9eff4"
};
